import * as ActionTypes from 'actions';

const initialState = {
  isVisible: false,
};

export default function(state = initialState, action = {}) {
  const { type } = action;

  switch (type) {
  case ActionTypes.NAVIGATION_SHOW:
    return { ...state, isVisible: true };

  case ActionTypes.NAVIGATION_HIDE:
    return { ...state, isVisible: false };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/navigation.js